import ArcGauge from '../ui/ArcGauge.jsx'
import RecapSection from '../ui/RecapSection.jsx'

export default function ParticipantDetail({ participant, onBack, onPrev, onNext }) {
  const k = participant.kart
  const sousTh = participant.sous_themes ?? []

  return (
    <div className="space-y-4">
      <button
        onClick={onBack}
        className="flex items-center gap-1 text-white/50 hover:text-white transition-colors text-sm"
      >
        ‹ Tous les joueurs
      </button>

      {/* En-tête joueur */}
      <div className="bg-gray-800 border border-white/10 rounded-2xl p-4 flex items-center gap-4">
        <span className="text-4xl leading-none shrink-0">{k.type_vehicule}</span>
        <div className="flex-1 min-w-0">
          <h2 className="text-white font-bold text-lg truncate">{k.pseudo}</h2>
          <p className="text-white/40 text-sm">Rang #{k.rang} sur {k.total_joueurs}</p>
        </div>
        <ArcGauge
          correctes={k.correctes} timeouts={k.timeouts}
          incorrectes={k.incorrectes} total={k.total} size={120}
        />
        {/* Navigation joueur précédent / suivant */}
        <div className="flex flex-col gap-1 shrink-0">
          <button
            onClick={onPrev}
            disabled={!onPrev}
            title="Joueur précédent"
            className="px-2 py-1.5 rounded-lg bg-white/5 border border-white/10 text-white/60 hover:text-white hover:bg-white/10 transition-colors disabled:opacity-25 disabled:pointer-events-none text-xs font-medium"
          >
            ▲ Préc.
          </button>
          <button
            onClick={onNext}
            disabled={!onNext}
            title="Joueur suivant"
            className="px-2 py-1.5 rounded-lg bg-white/5 border border-white/10 text-white/60 hover:text-white hover:bg-white/10 transition-colors disabled:opacity-25 disabled:pointer-events-none text-xs font-medium"
          >
            Suiv. ▼
          </button>
        </div>
      </div>

      {/* Compteurs */}
      <div className="grid grid-cols-3 gap-2">
        <div className="bg-gray-800 border border-white/10 rounded-xl p-3 text-center">
          <p className="text-green-400 font-bold text-xl">{k.correctes}</p>
          <p className="text-white/40 text-xs mt-0.5">✅ Correctes</p>
        </div>
        <div className="bg-gray-800 border border-white/10 rounded-xl p-3 text-center">
          <p className="text-slate-300 font-bold text-xl">{k.timeouts}</p>
          <p className="text-white/40 text-xs mt-0.5">⌛ Délais</p>
        </div>
        <div className="bg-gray-800 border border-white/10 rounded-xl p-3 text-center">
          <p className="text-red-400 font-bold text-xl">{k.incorrectes}</p>
          <p className="text-white/40 text-xs mt-0.5">❌ Incorrectes</p>
        </div>
      </div>

      {/* Analyse par sous-thème */}
      {k.total === 0 ? (
        <div className="flex flex-col items-center justify-center py-10 gap-3 text-white/40">
          <span className="text-4xl">📝</span>
          <p className="text-sm">Aucune réponse enregistrée pour ce joueur.</p>
        </div>
      ) : sousTh.length > 0 && (
        <div className="space-y-3">
          <p className="text-white/40 text-xs uppercase tracking-widest px-1">Analyse par sous-thème</p>
          {sousTh.map((st, i) => (
            <div key={i} className="bg-white/5 rounded-2xl p-4">
              <h3 className="text-white font-semibold text-sm mb-3">{st.nom}</h3>
              {/* 3 colonnes fixes sur desktop — placeholder vide si catégorie vide pour ne pas décaler */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                {st.maitrise.length > 0
                  ? <RecapSection label="Maîtrisé" color="green" items={st.maitrise} />
                  : <div className="hidden lg:block rounded-xl border border-white/5 bg-white/[0.02]" />}
                {st.acquis.length > 0
                  ? <RecapSection label="Acquis" color="amber" items={st.acquis} />
                  : <div className="hidden lg:block rounded-xl border border-white/5 bg-white/[0.02]" />}
                {st.a_reviser.length > 0
                  ? <RecapSection label="À réviser" color="red" items={st.a_reviser} />
                  : <div className="hidden lg:block rounded-xl border border-white/5 bg-white/[0.02]" />}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
